import React from 'react';
import { Link } from 'react-router-dom';
import fotoTradicaoExcelencia from '../assets/vinha_tradicao_excelencia.jpg';
import sujeito from '../assets/sujeito.png';
import { useT } from '../i18n/LanguageContext';

const TIMELINE_KEYS = [
  { yearKey: 'sobre.timeline.year.1923', textKey: 'sobre.timeline.1923' }, // 1986–2016
  { yearKey: 'sobre.timeline.year.1955', textKey: 'sobre.timeline.1955' }, // Ao longo deste caminho
  { yearKey: 'sobre.timeline.year.1982', textKey: 'sobre.timeline.1982' }, // Após 2016
  { yearKey: 'sobre.timeline.year.2005', textKey: 'sobre.timeline.2005' }, // 2020
  { yearKey: 'sobre.timeline.year.2018', textKey: 'sobre.timeline.2018' }, // 2023
];

const EQUIPA = [
  { nome: 'Manuel Maria Meneses', kBase: 'sobre.equipa.maria' },
  { nome: 'João Meneses',         kBase: 'sobre.equipa.joao'  },
  { nome: 'André Meneses',        kBase: 'sobre.equipa.ana'   },
];

export default function Sobre() {
  const t = useT();
  // Título tem \n para quebrar de linha
  const titleLines = t('sobre.title').split('\n');

  return (
    <div className="page-top">

      {/* ── Hero ── */}
      <section
        className="section"
        style={{
          background: `linear-gradient(160deg, rgba(14,7,4,0.65) 0%, rgba(14,7,4,0.35) 100%), url(${fotoTradicaoExcelencia}) center/cover no-repeat`,
          paddingTop: 'calc(var(--nav-height) + var(--sp-16))',
        }}
      >
        <div className="container">
          <div style={{ maxWidth: '640px' }}>
            <p className="t-label" style={{ color: '#ffffff', marginBottom: 'var(--sp-4)' }}>
              {t('sobre.eyebrow')}
            </p>
            <h1 className="t-h1 t-white" style={{ marginBottom: 'var(--sp-6)', textTransform: 'uppercase' }}>
              {titleLines[0]}{titleLines[1] && (<><br /><em>{titleLines[1]}</em></>)}
            </h1>
            <p className="t-body-lg" style={{ color: 'rgba(255,255,255,0.7)' }}>
              {t('sobre.lead')}
            </p>
          </div>
        </div>
      </section>

      {/* ── Stats ── */}
      <section className="section--sm" style={{ borderBottom: 'var(--border-thin)' }}>
        <div className="container">
          <div className="grid-4" style={{ textAlign: 'center' }}>
            {[
              { n: t('sobre.stat.foundationVal'), label: t('sobre.stat.foundation') },
              { n: t('sobre.stat.generationVal'), label: t('sobre.stat.generation') },
              { n: t('sobre.stat.vineyardVal'),   label: t('sobre.stat.vineyard')   },
              { n: t('sobre.stat.countriesVal'),  label: t('sobre.stat.countries')  },
            ].map(({ n, label }) => (
              <div key={label}>
                <p className="stat-label" style={{ marginBottom: 'var(--sp-2)' }}>{label}</p>
                <p className="stat-number">{n}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Missão ── */}
      <section className="section">
        <div className="container">
          <div className="grid-2" style={{ gap: 'var(--sp-16)', alignItems: 'center' }}>

            <img
              src={sujeito}
              alt="Sujeito"
              style={{
                aspectRatio: '3/4',
                objectFit: 'cover',
                width: '100%',
              }}
            />

            <div>
              <p className="t-label" style={{ color: '#000000', marginBottom: 'var(--sp-4)' }}>
                <span className="overline" /> {t('sobre.missao.eyebrow')}
              </p>
              <h2 className="t-h2" style={{ marginBottom: 'var(--sp-6)' }}>
                {t('sobre.missao.title')}
              </h2>
              <p className="t-body-lg t-light" style={{ marginBottom: 'var(--sp-4)' }}>
                {t('sobre.missao.p1')}
              </p>
              <p className="t-body t-light" style={{ marginBottom: 'var(--sp-8)' }}>
                {t('sobre.missao.p2')}
              </p>
              <Link to="/vinhas" className="btn">
                {t('sobre.missao.cta')}
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ── Timeline ── */}
      <section className="section bg-areia">
        <div className="container">
          <div className="section-header--centered">
            <p className="t-label" style={{ color: '#000000', marginBottom: 'var(--sp-4)' }}>
              {t('sobre.timeline.eyebrow')}
            </p>
            <h2 className="t-h2">{t('sobre.timeline.title')}</h2>
          </div>

          <div className="timeline">
            {/* Linha vertical */}
            <div className="timeline__line" />

            {TIMELINE_KEYS.map(({ yearKey, textKey }) => (
              <div key={yearKey} className="timeline__row">
                <div className="timeline__year">
                  <span className="t-label" style={{ color: '#000000', display: 'block', lineHeight: 1.25 }}>
                    {t(yearKey)}
                  </span>
                  <span className="timeline__dot" />
                </div>
                <p className="t-body" style={{ paddingTop: '2px' }}>{t(textKey)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Equipa ── */}
      <section className="section">
        <div className="container">
          <div className="section-header--centered">
            {/* Etiqueta pequena removida a pedido — repetia o texto do
                título grande logo a seguir ("A família" / "A família").
                Comentado, não apagado, para repor facilmente se precisar.
            <p className="t-label" style={{ color: '#000000', marginBottom: 'var(--sp-4)' }}>
              {t('sobre.equipa.eyebrow')}
            </p>
            */}
            <h2 className="t-h2">{t('sobre.equipa.title')}</h2>
          </div>

          <div className="grid-3">
            {EQUIPA.map(({ nome, kBase }) => (
              <div
                key={nome}
                style={{
                  padding: 'var(--sp-8)',
                  border: 'var(--border-thin)',
                  textAlign: 'center',
                }}
              >
                {/* Avatar placeholder */}
                <div style={{
                  width: 80,
                  height: 80,
                  borderRadius: '50%',
                  background: 'var(--clr-branco)',
                  border: '1px solid #000000',
                  margin: '0 auto var(--sp-5)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 'var(--fz-xl)',
                  fontFamily: 'var(--font-serif)',
                  color: '#000000',
                }}>
                  {nome[0]}
                </div>
                <h3 className="t-h4" style={{ marginBottom: 'var(--sp-2)' }}>{nome}</h3>
                <p className="t-label" style={{ color: '#000000', marginBottom: 'var(--sp-4)' }}>
                  {t(`${kBase}.cargo`)}
                </p>
                <p className="t-small t-light">{t(`${kBase}.bio`)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
